import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { notificationListing, notificationOptions, sendNotification, viewNotification } from "../apis/apiHandler";

export const allNotifications = createAsyncThunk(
    'notification/list',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await notificationListing(payload);
            if (response?.code === 200) return response;
            return rejectWithValue(response);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const notificationOption = createAsyncThunk(
    'notification/options',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await notificationOptions(payload);
            if (response?.code === 200) return response;
            return rejectWithValue(response);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const addNotification = createAsyncThunk(
    'notification/add',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await sendNotification(payload);
            if (response?.code === 200) return response;
            return rejectWithValue(response);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

export const viewNotificationDetails = createAsyncThunk(
    'notification/view',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await viewNotification(payload);
            if (response?.code === 200) return response;
            return rejectWithValue(response);
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
)

const initialState = {
    loading: false,
    notificationList: [],
    error: null,
    addSuccess: false,
    notificationDetail: {},
    // ✅ Fixed: was 'notificationOptionList' in selector but 'notificationOption' in fulfilled
    notificationOptionList: {
        tutors: [],
        parents: [],
        tutor_pagination: {},
        parent_pagination: {},
    },
};

const NotificationSlice = createSlice({
    name: 'notification',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(allNotifications.pending, (state) => {
                state.loading = true;
            })
            .addCase(allNotifications.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.notificationList = payload?.data;
            })
            .addCase(allNotifications.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            .addCase(addNotification.pending, (state) => {
                state.loading = true;
                state.addSuccess = false;
                state.error = null;
            })
            .addCase(addNotification.fulfilled, (state) => {
                state.loading = false;
                state.addSuccess = true;
            })
            .addCase(addNotification.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.addSuccess = false;
            })

            .addCase(notificationOption.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(notificationOption.fulfilled, (state, { payload }) => {
                state.loading = false;
                // ✅ Fixed: store under 'notificationOptionList' to match selector
                state.notificationOptionList = payload?.data;
            })
            .addCase(notificationOption.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            .addCase(viewNotificationDetails.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(viewNotificationDetails.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.notificationDetail = payload?.data;
            })
            .addCase(viewNotificationDetails.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
    }
})

export default NotificationSlice.reducer;